// extracted by mini-css-extract-plugin
export default {"backgroundIcon":"backgroundIcon--eXOBd","bzObjTypeHeading":"bzObjTypeHeading--rBrXK"};